module.exports = __webpack_public_path__ + "static/media/logo.fca2e89e.svg";